module.exports = __webpack_public_path__ + "static/SFWSC-Double-Gold-2-200x200-73063f69b820bb4f9720ef4767930cfc.png";